var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlwaysUptoDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Page-1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.501,
    height: 54.512,
    viewBox: "0 0 54.501 54.512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_030---Update-Schedule",
    "data-name": "030---Update-Schedule"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M49.051,24.691V7.267A4.547,4.547,0,0,0,44.51,2.725H39.06a2.725,2.725,0,0,0-5.45,0H15.442a2.725,2.725,0,0,0-5.45,0H4.542A4.547,4.547,0,0,0,0,7.267V43.6a4.547,4.547,0,0,0,4.542,4.542H23.876A17.243,17.243,0,1,0,49.051,24.691ZM33.609,5.331V6.359a2.725,2.725,0,1,0,5.45,0V5.331a3.217,3.217,0,0,1,.908,2.215,3.645,3.645,0,0,1-7.267,0A3.217,3.217,0,0,1,33.609,5.331Zm1.817-2.606a.908.908,0,0,1,1.817,0V6.359a.908.908,0,0,1-1.817,0ZM9.992,5.331V6.359a2.725,2.725,0,1,0,5.45,0V5.331a3.216,3.216,0,0,1,.908,2.215A3.505,3.505,0,0,1,12.717,10.9,3.505,3.505,0,0,1,9.084,7.547a3.217,3.217,0,0,1,.908-2.215Zm1.817-2.606a.908.908,0,1,1,1.817,0V6.359a.908.908,0,1,1-1.817,0ZM4.542,4.542H8.3a4.982,4.982,0,0,0-1.029,3,5.322,5.322,0,0,0,5.45,5.17,5.322,5.322,0,0,0,5.45-5.17,4.982,4.982,0,0,0-1.029-3H31.913a4.982,4.982,0,0,0-1.029,3,5.457,5.457,0,0,0,10.9,0,4.982,4.982,0,0,0-1.029-3H44.51a2.725,2.725,0,0,1,2.725,2.725v7.267H1.817V7.267A2.725,2.725,0,0,1,4.542,4.542Zm0,41.785A2.725,2.725,0,0,1,1.817,43.6V16.35H47.235V23.2a17.114,17.114,0,0,0-16.35-1.984V19.984a1.817,1.817,0,0,0-1.817-1.817H25.434a1.817,1.817,0,0,0-1.817,1.817v2.725a1.817,1.817,0,0,0,1.817,1.817h.182a17.146,17.146,0,0,0-3.02,21.8Zm23.43-23.617H25.434V19.984h3.633v2.065C28.691,22.255,28.331,22.479,27.972,22.709Zm9.271,29.976A15.442,15.442,0,1,1,52.685,37.243,15.442,15.442,0,0,1,37.243,52.685Z",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M9.45,20H5.817A1.817,1.817,0,0,0,4,21.817v2.725a1.817,1.817,0,0,0,1.817,1.817H9.45a1.817,1.817,0,0,0,1.817-1.817V21.817A1.817,1.817,0,0,0,9.45,20ZM5.817,24.542V21.817H9.45v2.725Z",
    transform: "translate(-0.367 -1.833)",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M16.817,26.359H20.45a1.817,1.817,0,0,0,1.817-1.817V21.817A1.817,1.817,0,0,0,20.45,20H16.817A1.817,1.817,0,0,0,15,21.817v2.725A1.817,1.817,0,0,0,16.817,26.359Zm0-4.542H20.45v2.725H16.817Z",
    transform: "translate(-1.375 -1.833)",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    d: "M9.45,30H5.817A1.817,1.817,0,0,0,4,31.817v2.725a1.817,1.817,0,0,0,1.817,1.817H9.45a1.817,1.817,0,0,0,1.817-1.817V31.817A1.817,1.817,0,0,0,9.45,30ZM5.817,34.542V31.817H9.45v2.725Z",
    transform: "translate(-0.367 -2.749)",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    d: "M20.45,30H16.817A1.817,1.817,0,0,0,15,31.817v2.725a1.817,1.817,0,0,0,1.817,1.817h1.817a.908.908,0,1,0,0-1.817H16.817V31.817H20.45a.908.908,0,1,0,0-1.817Z",
    transform: "translate(-1.375 -2.749)",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-6",
    "data-name": "Shape",
    d: "M9.45,40H5.817A1.817,1.817,0,0,0,4,41.817v2.725a1.817,1.817,0,0,0,1.817,1.817H9.45a1.817,1.817,0,0,0,1.817-1.817V41.817A1.817,1.817,0,0,0,9.45,40ZM5.817,44.542V41.817H9.45v2.725Z",
    transform: "translate(-0.367 -3.666)",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-7",
    "data-name": "Shape",
    d: "M19.542,44.542H16.817V41.817h1.817a.908.908,0,1,0,0-1.817H16.817A1.817,1.817,0,0,0,15,41.817v2.725a1.817,1.817,0,0,0,1.817,1.817h2.725a.908.908,0,0,0,0-1.817Z",
    transform: "translate(-1.375 -3.666)",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-8",
    "data-name": "Shape",
    d: "M31.185,39.543A.908.908,0,0,0,29.9,38.258l-.157.157A9.985,9.985,0,0,1,48.71,35.647a.908.908,0,0,0,1.65-.759,11.809,11.809,0,0,0-22.478,3.7l-.33-.33a.908.908,0,0,0-1.284,1.284l1.817,1.817a.908.908,0,0,0,1.284,0Z",
    transform: "translate(-2.384 -2.566)",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-9",
    "data-name": "Shape",
    d: "M50.168,39.266l-1.817,1.817a.908.908,0,0,0,1.284,1.284l.157-.157a9.985,9.985,0,0,1-18.967,2.769.908.908,0,0,0-1.65.759,11.809,11.809,0,0,0,22.478-3.7l.33.33a.908.908,0,0,0,1.284-1.284l-1.817-1.817a.908.908,0,0,0-1.284,0Z",
    transform: "translate(-2.667 -3.574)",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-10",
    "data-name": "Shape",
    d: "M40.726,45.992a.908.908,0,0,0,.908-.908V39.1l.266.266a.908.908,0,0,0,1.284-1.284l-1.817-1.817a.908.908,0,0,0-1.284,0l-1.817,1.817a.908.908,0,0,0,1.284,1.284l.266-.266v5.982a.908.908,0,0,0,.908.908Z",
    transform: "translate(-3.483 -3.299)",
    fill: "#7b7bff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlwaysUptoDate);
export default __webpack_public_path__ + "static/media/always-upto-date.66fbc80a83b8a5af2786b83038737651.svg";
export { ForwardRef as ReactComponent };